export default __webpack_public_path__ + "static/media/slideup2.d2254898.jpeg";